export default {"src":"/_next/static/media/notFound.e8080af4.svg","height":571,"width":860};